module.exports = __webpack_public_path__ + "static/img/335_TO8_2584.ae80026.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/335_TO8_2584.jpg
// module id = +IlD
// module chunks = 0